import { render, staticRenderFns } from "./HubAvatar.vue?vue&type=template&id=8ef11830"
import script from "./HubAvatar.vue?vue&type=script&lang=js"
export * from "./HubAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports